/// <reference path="../../components/webComponents/services/webComponentSetup.service.ts" />
/// <reference path="./modelQuantityAnalysis.module.ts" />

/**
 * Inventory Analysis — shared Web Component Registration
 *
 * Registers the shared <meevo-inventory-analysis> web component for all three
 * inventory analysis plugins. The plugin host supplies data-analysis-type;
 * the mount hook forwards that value to the WC's analysisType input.
 *
 * Each wizard signals a "user clicked close" intent via window.postMessage.
 * We translate any of those close events into the shell's CLOSE_CONTEXT broadcast.
 *
 * Feature gate: each plugin's own Gate controller (see e.g.
 * ModelQuantityAnalysisGateController) checks its business setting and only
 * renders <web-component-mount> when enabled — this WC is always ungated in
 * webComponentRegistry.json. That covers every entry path (menu, convo bar,
 * deep link), since all of them land on the same plugin page.
 */
angular.module('meevo.plugins.modelQuantityAnalysis').run([
    'webComponentSetup',
    '$rootScope',
    '$state',
    function (
        webComponentSetup: any,
        $rootScope: angular.IRootScopeService,
        $state: any,
    ) {
        // Single open instance at any time, so a module-scoped handler is fine.
        var messageHandler: ((evt: MessageEvent) => void) | null = null;

        function findAnalysisType(element: HTMLElement): string | null {
            var current: HTMLElement | null = element;
            while (current) {
                var value = current.getAttribute('data-analysis-type');
                if (value) {
                    return value;
                }
                current = current.parentElement;
            }
            return null;
        }

        webComponentSetup.register({
            id: 'meevo-inventory-analysis',
            tag: 'meevo-inventory-analysis',
            scriptPath: '/lib/meevo-inventory-analysis.js',

            onMount: function (element: HTMLElement): void {
                var analysisType = findAnalysisType(element);
                if (analysisType === 'modelQuantity' || analysisType === 'inventoryTurns' || analysisType === 'slowMoving') {
                    (element as any).analysisType = analysisType;
                } else {
                    console.warn('[InventoryAnalysis] Missing or invalid data-analysis-type on mount host.');
                }

                messageHandler = function (evt: MessageEvent): void {
                    const data = evt && (evt as any).data;
                    if (!data || typeof data !== 'object') return;
                    var eventType = (data as any).type;
                    if (eventType !== 'mqa:close' && eventType !== 'ita:close' && eventType !== 'sma:close') return;
                    $rootScope.$apply(function (): void {
                        $rootScope.$broadcast(
                            Meevo.Components.Common.Messages.CLOSE_CONTEXT,
                            $state['current'],
                            null,
                        );
                    });
                };
                window.addEventListener('message', messageHandler);
            },

            onUnmount: function (_element: HTMLElement): void {
                if (messageHandler) {
                    window.removeEventListener('message', messageHandler);
                    messageHandler = null;
                }
            },
        });
    }
]);
